module.exports = __webpack_public_path__ + "img/minus.b4ea9117.svg";